import {
  IDocumentMediaPreviewData,
  IMessage,
  IMessageData,
  MESSAGE_CONTENT_TYPE,
} from "@home-health-notify/domain";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "hhn-commons";
import React, { useContext, useEffect, useState } from "react";
import CustomDrawer from "../../../../common/CustomDrawer";
import { DocumentMediaViewerContext } from "../../../../context/DocumentMediaViewerContext";
import { RightDrawerContext } from "../../../../context/RightDrawerContext";
import DisplayThumbImage from "../../../../message/mediaViewer/mediaThumb/DisplayThumbImage";
import VideoThumb from "../../../../message/mediaViewer/mediaThumb/VideoThumb";
import { VideoThumbnail } from "../../../../uploader/Preview.style";
import ChatAssetsTabs from "./assets/ChatAssetsTabs";
import DocumentThumbBox from "./DocumentThumbBox";
import { MediaBox } from "./MediaDocumentInfo.style";

export const MediaDocumentInfo = ({ mediaList }: { mediaList: IMessage[] }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });
  const { open } = useContext(RightDrawerContext);
  const [openChatAssets, setOpenChatAssets] = useState<boolean>(false);
  const isAssetExist = mediaList && mediaList.length > 0;
  const { openDocumentMediaViewer } = useContext(DocumentMediaViewerContext);
  const onMediaMessageClicked = (message: IMessage) => {
    const previewMedia: IDocumentMediaPreviewData =
      message.getPreviewDataFromMessage()!;
    const previewMediaList: IDocumentMediaPreviewData[] = mediaList.map(
      message => {
        return message.getPreviewDataFromMessage()!;
      },
    );
    openDocumentMediaViewer(previewMedia, previewMediaList);
  };

  const onOpenChatAssets = () => {
    if (isAssetExist) setOpenChatAssets(true);
  };

  useEffect(() => {
    if (!open) setOpenChatAssets(false);
  }, [open]);
  return (
    <Box sx={{ padding: "20px" }} data-testid="attachments">
      <CustomDrawer
        open={openChatAssets}
        fullWidth={true}
        testId="group-asset-drawer"
      >
        {openChatAssets && (
          <ChatAssetsTabs onClose={() => setOpenChatAssets(false)} />
        )}
      </CustomDrawer>
      <Typography
        sx={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          cursor: isAssetExist ? "pointer" : "auto",
        }}
        onClick={onOpenChatAssets}
      >
        {tNs("attachments")} {isAssetExist && <KeyboardArrowRightIcon />}
      </Typography>
      <Box
        sx={{
          display: "flex",
          overflow: "auto",
          width: "inherit"
        }}>
        {isAssetExist ? (
          mediaList.map((mediaMsg: IMessage) => {
            const message: IMessageData = mediaMsg.getMessage();
            return (
              <Box
                key={message.id}
                sx={{ cursor: "pointer" }}
                data-testid="media-info-item"
                onClick={() => onMediaMessageClicked(mediaMsg)}
              >
                {message.contentType === MESSAGE_CONTENT_TYPE.IMAGE &&
                  message.images &&
                  message.images.length > 0 && (
                    <>
                      {message.images.map((image, index) => {
                        return (
                          <MediaBox key={index}>
                            <DisplayThumbImage
                              imageData={image}
                              style={{
                                objectFit: "cover",
                                width: "inherit",
                                height: "inherit",
                                borderRadius: "5px",
                                padding: 1,
                              }}
                            />
                          </MediaBox>
                        );
                      })}
                    </>
                  )}
                {message.contentType === MESSAGE_CONTENT_TYPE.VIDEO &&
                  message.videos &&
                  message.videos.length > 0 && (
                    <>
                      {message.videos.map((video, index) => (
                        <MediaBox key={index}>
                          <VideoThumb
                            videoData={video}
                            style={{
                              objectFit: "cover",
                              width: "inherit",
                              height: "inherit",
                              borderRadius: "5px",
                              padding: 1,
                            }}
                          />
                          <VideoThumbnail fontSize="large" />
                        </MediaBox>
                      ))}
                    </>
                  )}
                {message.contentType === MESSAGE_CONTENT_TYPE.DOCUMENT &&
                  message.documents &&
                  message.documents.length > 0 && (
                    <>
                      {message.documents.map((document, index) => (
                        <MediaBox key={index}>
                          <DocumentThumbBox
                            fileName={document.text}
                            url={document.url}
                          />
                        </MediaBox>
                      ))}
                    </>
                  )}
              </Box>
            );
          })
        ) : (
          <Typography>{tNs("noMedia")}</Typography>
        )}
      </Box>
    </Box>
  );
};
